import React, { Fragment, memo } from 'react';

import ProductGroupTitle from 'components/ProductGrid/Group/Title';
import BuilderGroupTitle from 'components/ProductGrid/Group/BuilderTitle';
import ProductList from 'components/ProductList';
import ProductGridItems from 'components/ProductGrid/ProductGridItems';

import { ProductGroupProps } from './types';

const ProductGroup = memo(
  ({
    autoFocusIndex,
    isBuilderPage = false,
    listId,
    products = [],
    contextProducts = [],
    searchType = null,
    taxonomyLevel = null,
    titleElement,
    title,
    listDefinitions,
  }: ProductGroupProps) => (
    <Fragment>
      {isBuilderPage ? (
        <BuilderGroupTitle title={title} />
      ) : (
        <ProductGroupTitle titleElement={titleElement} withBorder title={title} />
      )}
      <ProductList withContainer={false} withSpinner={false}>
        <ProductGridItems
          autoFocusIndex={autoFocusIndex}
          items={products}
          isBuilderPage={isBuilderPage}
          listId={listId}
          contextItems={contextProducts}
          // @ts-expect-error untyped component
          searchType={searchType}
          // @ts-expect-error untyped component
          taxonomyLevel={taxonomyLevel}
          listDefinitions={listDefinitions}
        />
      </ProductList>
    </Fragment>
  ),
);

ProductGroup.displayName = 'ProductGroup';

export default ProductGroup;
